import NotFoundPage from '../pages/404.vue';
// MOPECO
import Exploitation from '../pages/exploitation.vue';
import Floor from '../pages/floor.vue';
import Irrigation from '../pages/irrigation.vue';
import Crops from '../pages/crops.vue';
import OptimalCropDistribution from '../pages/optimalCropDistribution.vue';
import OptimalCropDistributionAdvanced from '../pages/optimalCropDistributionAdvanced.vue';

const routes = [
  // Default
  {
    path: '/',
    component: Exploitation,
  },
  // MOPECO
  {
    path: '/exploitation/',
    component: Exploitation,
  },
  {
    path: '/floor/',
    component: Floor,
  },
  {
    path: '/irrigation/',
    component: Irrigation,
  },
  {
    path: '/crops/',
    component: Crops,
  },
  {
    path: '/optimalCropDistribution/',
    component: OptimalCropDistribution,
  },
  {
    path: '/optimalCropDistributionAdvanced/',
    component: OptimalCropDistributionAdvanced,
  },
  // No found
  {
    path: '(.*)',
    component: NotFoundPage,
  },
];

export default routes;
